import React from 'react';

const Spinner = ({ type = '' }) => {
  if (type === 'pie') {
    return (
      <div className="pie-chart-skeleton-wrapper">
        <div className="pie-chart-skeleton shimmer"></div>
        <div className="pie-chart-loading-text">Loading data...</div>
      </div>
    );
  }

  return (
    <div className="chart-skeleton-container">
      <div className="skeleton-title shimmer" />
      <div className="skeleton-subtitle shimmer" />

      <div className="skeleton-chart-area">
        <div className="skeleton-bars">
          {[50, 20, 30, 80, 60, 70, 65, 60, 40, 55, 30, 70].map((height, index) => (
            <div
              key={index}
              className="skeleton-bar shimmer"
              style={{ height: `${height}%` }}
            />
          ))}
        </div>
        <div className="skeleton-loading-text">Loading data...</div>
      </div>
    </div>
  );
};

export default Spinner;
